import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  connect() {
    // Close dropdown when clicking outside
    this.boundClose = this.close.bind(this)
    this.isOpen = false
  }

  disconnect() {
    this.removeClickListener()
  }

  toggle(event) {
    event.stopPropagation()

    if (this.isOpen) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    // Close any other open dropdowns by dispatching a custom event
    document.querySelectorAll('[data-controller="dropdown"]').forEach(element => {
      if (element !== this.element) {
        const controller = this.application.getControllerForElementAndIdentifier(element, "dropdown")
        if (controller && controller.isOpen) {
          controller.close()
        }
      }
    })

    this.menuTarget.classList.remove("opacity-0", "hidden")
    this.menuTarget.classList.add("opacity-100")
    this.isOpen = true

    // Listen for clicks outside
    setTimeout(() => {
      document.addEventListener("click", this.boundClose)
    }, 0)
  }

  close(event) {
    if (event && this.element.contains(event.target)) {
      return
    }

    this.menuTarget.classList.add("opacity-0", "hidden")
    this.menuTarget.classList.remove("opacity-100")
    this.isOpen = false
    this.removeClickListener()
  }

  removeClickListener() {
    document.removeEventListener("click", this.boundClose)
  }
}
